namespace GeniuzPOS.InitialData {
    export class PsShopColumns {
        static columnsKey = 'InitialData.PsShop';
    }
}
